import { IPublicSession } from 'state/session';
import { State } from 'utils/state';

export function fullScreenAutomation(state: State<IPublicSession>) {
  state.on('beforechange', (keys, arrValues, arrOldValues, sessionChanges, currentSession) => {
    // Observe changes only in streamActive and isShared
    if (keys.includes('streamActive') || keys.includes('isShared')) {
      const { streamActive, sharingType, isShared } = {
        ...currentSession,
        ...sessionChanges,
      };

      if (streamActive && sharingType === 'remote' && isShared) {
        state.setValues({ streamFullScreen: true }, { emit: false });
      }

      if (!streamActive || !isShared) {
        state.setValues({ streamFullScreen: false }, { emit: false });
      }
    }
  });
}
